import { render, staticRenderFns } from "./ApprovalBubble.vue?vue&type=template&id=3ed109d6"
import script from "./ApprovalBubble.vue?vue&type=script&lang=js"
export * from "./ApprovalBubble.vue?vue&type=script&lang=js"
import style0 from "./ApprovalBubble.vue?vue&type=style&index=0&id=3ed109d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports